import { render, staticRenderFns } from "./BasePageTitle.vue?vue&type=template&id=5cf5ac1e&scoped=true"
import script from "./BasePageTitle.vue?vue&type=script&lang=js"
export * from "./BasePageTitle.vue?vue&type=script&lang=js"
import style0 from "./BasePageTitle.vue?vue&type=style&index=0&id=5cf5ac1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5ac1e",
  null
  
)

export default component.exports